export var SquircleButtonVariant;

(function (SquircleButtonVariant) {
  SquircleButtonVariant["PRIMARY"] = "primary";
  SquircleButtonVariant["DESTRUCTIVE"] = "destructive";
  SquircleButtonVariant["INSTRUCTIVE"] = "instructive";
  SquircleButtonVariant["WARNING"] = "warning";
  SquircleButtonVariant["GHOST"] = "ghost";
  SquircleButtonVariant["DARK_GHOST"] = "darkGhost";
  SquircleButtonVariant["BLACK"] = "black";
  SquircleButtonVariant["WHITE"] = "white";
  SquircleButtonVariant["DEFAULT"] = "default";
})(SquircleButtonVariant || (SquircleButtonVariant = {}));